<h3 mat-dialog-title *ngIf="data.title">{{ data.title }}</h3>
<mat-dialog-content>
  <div tabindex="0" [innerHTML]="data.body | safeHtml:'html' " class="mat-typography"></div>
  <p style="text-align: center;">
    <button tabindex="0" mat-raised-button id="orderconfirmation_ok" class="nsc-button"  type="button" color="primary" (click)="close()">
    {{confirmMessage}}
    </button>
  </p>
</mat-dialog-content>
